<footer class="app-footer">
  <div class="app-footer__inner">
    <p class="app-footer__copy">© {{ year }} PulseWatch · Swiss made</p>
    <nav class="app-footer__links" aria-label="Footer">
      <a routerLink="/knowledge-base">Docs</a>
      <a routerLink="/main/account">Account</a>
    </nav>
    <p class="app-footer__version" data-testid="footer-version" [title]="'Built ' + (versions.date | date: 'medium')">
      <span class="dot" aria-hidden="true"></span>
      Version <code>{{ versions.hash }}</code> · {{ versions.date | date: 'mediumDate' }}
    </p>
  </div>
</footer>
